/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../../Configuration';
import { RestServiceProvider } from '../../RestServiceProvider';
import {ActionRequestProgMesService} from "./ActionRequestProgMesService";

class ActionRequestProgMesServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new ActionRequestProgMesService($q, resource, $httpParamSerialiserJQLike, $log);
    }

    getCompleteConfig(url) {
        return {
            url: url + Configuration.COMPLETE_ACTION_REQUEST_PATH,
            method: 'PATCH',
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? null : angular.fromJson(data)
        };
    }

    getReopenConfig(url) {
        return {
            url: url + Configuration.REOPEN_ACTION_REQUEST_PATH,
            method: 'PATCH',
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? null : angular.fromJson(data)
        };
    }

    getCloseConfig(url) {
        return {
            url: url + Configuration.CLOSE_ACTION_REQUEST_PATH,
            method: 'PATCH',
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? null : angular.fromJson(data)
        };
    }

    getCancelConfig(url) {
        return {
            url: url + Configuration.CANCEL_ACTION_REQUEST_PATH,
            method: 'PATCH',
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? null : angular.fromJson(data)
        };
    }

    /** @ngInject */
    getConfig() {
        const config = super.getConfig();
        config.complete = this.getCompleteConfig(this.resourceUrl);
        config.reopen = this.getReopenConfig(this.resourceUrl);
        config.close = this.getCloseConfig(this.resourceUrl);
        config.cancel = this.getCancelConfig(this.resourceUrl);
        return config;
    }
}

export { ActionRequestProgMesServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/ActionRequestProgMesServiceProvider.js